import { render } from "./EmbedFeedback.vue?vue&type=template&id=02be43b3"
import script from "./EmbedFeedback.vue?vue&type=script&lang=js"
export * from "./EmbedFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__